<template>
  <div class="woody-steale slide">
    <HorizontalAnimation :animation="animation" :loop=false />
    <div class="horizontal-layout animated fadeIn delay-2s">
      <p class="store">STORE 1763</p>
      <h1>Woody Steale</h1>
      <p>The blitz is successful and results in an apprehension at store 1763. The suspect – identified as <strong>Woody Steale</strong> – admits to selling stolen merchandise to an individual known only as Rob. Steale also reveals that Rob drives an orange pickup, possibly the same one seen <br /> at store 1755.</p>
    </div>
    <router-link to="/trivia-15">
      <NextButton />
    </router-link>
  </div>
</template>

<script>
import HorizontalAnimation from '@/components/HorizontalAnimation.vue'
import NextButton from '@/components/NextButton.vue'
import WoodySteale from '@/assets/woody-steale.js'

export default {
  name: 'woody-steale',
  components: {
    HorizontalAnimation,
    NextButton
  },
  data() {
    return {
      animation: WoodySteale
    }
  },
  mounted() {
    window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
  }
}
</script>

<style lang="scss" scoped>
  .horizontal-layout {
    margin-top:10px;
  }
</style>
